import React from "react"
import ReactDOM from "react-dom"
import AppWithRouting from "./AppWithRouting"
//import "bootstrap/dist/css/bootstrap.min.css"
ReactDOM.render(<AppWithRouting />, document.getElementById("root"))
